module.exports = __webpack_public_path__ + "img/4.f2aa71d9.jpg";